var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _c('form-component', {
    ref: "form",
    attrs: {
      "formData": _vm.formData
    },
    scopedSlots: _vm._u([{
      key: "freezer-ui-section",
      fn: function () {
        return [_c('div', {
          staticClass: "generate-button"
        }, [_vm.isGenerating ? _c('v-progress-circular', {
          attrs: {
            "indeterminate": "",
            "color": "primary"
          }
        }) : _c('v-btn', {
          attrs: {
            "color": "primary",
            "depressed": "",
            "clearable": "",
            "disabled": !_vm.displayGenButton
          },
          on: {
            "click": function ($event) {
              return _vm.generateFreezerUi();
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.generatedUi ? 'Regenerate' : 'Generate') + " ")])], 1), _vm.generatedUi && !_vm.isGenerating ? _c('div', [_c('div', {
          staticClass: "freezerUi"
        }, _vm._l(_vm.shelves, function (shelf) {
          return _c('div', {
            key: shelf.shelfNo,
            staticClass: "shelf-wrapper"
          }, [_c('div', {
            staticClass: "shelf-header"
          }, [_c('div', {
            staticClass: "shelf-title"
          }, [_vm._v(" Shelf " + _vm._s(shelf.shelfNo) + " ")]), _c('div', {
            staticClass: "shelf-controls"
          }, [_c('v-text-field', {
            staticClass: "column-input",
            attrs: {
              "type": "number",
              "label": "Columns",
              "outlined": "",
              "dense": "",
              "hide-details": "",
              "min": "1",
              "max": "5",
              "rules": [function (v) {
                return !!v || 'No of Column is required';
              }, function (v) {
                return Number.isInteger(Number(v)) || 'Must be a whole number';
              }, function (v) {
                return v >= 1 || 'Minimum is 1 column';
              }, function (v) {
                return v <= 5 || 'Maximum is 5 columns';
              }]
            },
            model: {
              value: shelf.noOfColumn,
              callback: function ($$v) {
                _vm.$set(shelf, "noOfColumn", $$v);
              },
              expression: "shelf.noOfColumn"
            }
          }), _c('v-btn', {
            attrs: {
              "color": "primary",
              "depressed": "",
              "small": "",
              "loading": shelf.isGeneratingColumn,
              "disabled": shelf.noOfColumn > 5 || shelf.noOfColumn < 1 || shelf.contents.length === Number(shelf.noOfColumn)
            },
            on: {
              "click": function ($event) {
                return _vm.generateColumn(shelf);
              }
            }
          }, [_vm._v(" " + _vm._s(shelf.contents.length ? 'Regenerate' : 'Generate') + " ")])], 1)]), _c('div', {
            staticClass: "shelf-body",
            style: {
              gridTemplateColumns: ("repeat(" + (shelf.contents.length) + ", 1fr)")
            }
          }, _vm._l(shelf.contents, function (content) {
            return _c('div', {
              key: content.columnNo,
              staticClass: "freezer-column"
            }, [_c('div', {
              staticClass: "column-label"
            }, [_c('span', [_vm._v(" Column " + _vm._s(content.columnNo) + " ")]), _c('v-btn', {
              attrs: {
                "icon": "",
                "x-small": "",
                "color": "red"
              },
              on: {
                "click": function ($event) {
                  $event.stopPropagation();
                  return _vm.removeColumn(shelf, content.columnNo);
                }
              }
            }, [_c('v-icon', {
              attrs: {
                "small": ""
              }
            }, [_vm._v(" mdi-delete-outline ")])], 1)], 1), _c('div', {
              staticClass: "column-content"
            }, [content.type && content.type.toLowerCase() !== 'empty' ? _c('div', {
              staticClass: "column-form-wrapper"
            }, [_c('div', {
              staticClass: "column-form-header"
            }, [_c('v-icon', {
              attrs: {
                "size": "34",
                "color": _vm.getColumnColor(content.type)
              }
            }, [_vm._v(" " + _vm._s(_vm.getColumnIcon(content.type)) + " ")]), _c('div', {
              staticClass: "column-form-title"
            }, [_vm._v(" " + _vm._s(content.type) + " ")])], 1), _c('v-form', {
              staticClass: "column-form",
              attrs: {
                "fast-fail": ""
              },
              on: {
                "submit": function ($event) {
                  $event.preventDefault();
                }
              }
            }, [content.type.toLowerCase() === 'rack' ? _c('v-text-field', {
              staticClass: "mb-3",
              attrs: {
                "label": "Sliding Racks",
                "outlined": "",
                "dense": "",
                "hide-details": "auto",
                "prepend-inner-icon": "mdi-view-carousel",
                "rules": [function (v) {
                  return !!v || 'Sliding Racks is required';
                }]
              },
              model: {
                value: content.slidingRacksNo,
                callback: function ($$v) {
                  _vm.$set(content, "slidingRacksNo", $$v);
                },
                expression: "content.slidingRacksNo"
              }
            }) : _vm._e(), _c('v-text-field', {
              staticClass: "mb-3",
              attrs: {
                "label": "Content Name",
                "outlined": "",
                "dense": "",
                "hide-details": "auto",
                "prepend-inner-icon": "mdi-tag-outline"
              },
              model: {
                value: content.name,
                callback: function ($$v) {
                  _vm.$set(content, "name", $$v);
                },
                expression: "content.name"
              }
            }), _c('v-textarea', {
              staticClass: "scrollable-textarea",
              attrs: {
                "clearable": "",
                "label": "Notes",
                "outlined": "",
                "dense": "",
                "auto-grow": "",
                "rows": "3",
                "hide-details": "auto",
                "prepend-inner-icon": "mdi-note-text-outline"
              },
              model: {
                value: content.notes,
                callback: function ($$v) {
                  _vm.$set(content, "notes", $$v);
                },
                expression: "content.notes"
              }
            })], 1)], 1) : _c('div', [_c('v-icon', {
              attrs: {
                "size": "55",
                "color": _vm.getColumnColor(content.type)
              }
            }, [_vm._v(" " + _vm._s(_vm.getColumnIcon(content.type)) + " ")]), _c('div', {
              staticClass: "column-type"
            }, [_vm._v(" " + _vm._s(content.type || 'Unassigned') + " ")])], 1), _c('div', {
              staticClass: "column-select"
            }, [_c('v-select', {
              attrs: {
                "items": _vm.storageTypes,
                "item-text": "label",
                "item-value": "value",
                "label": "Storage Type",
                "outlined": "",
                "dense": "",
                "hide-details": "",
                "prepend-inner-icon": "mdi-database"
              },
              on: {
                "change": function ($event) {
                  return _vm.onStorageTypeChange(content);
                }
              },
              scopedSlots: _vm._u([{
                key: "item",
                fn: function (_ref) {
                  var item = _ref.item;
                  return [_c('v-list-item-icon', [_c('v-icon', {
                    attrs: {
                      "color": item.color
                    }
                  }, [_vm._v(" " + _vm._s(item.icon) + " ")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(item.label) + " ")])], 1)];
                }
              }], null, true),
              model: {
                value: content.type,
                callback: function ($$v) {
                  _vm.$set(content, "type", $$v);
                },
                expression: "content.type"
              }
            })], 1)])]);
          }), 0)]);
        }), 0)]) : _vm._e()];
      },
      proxy: true
    }, {
      key: "description-section",
      fn: function () {
        return [_c('v-textarea', {
          attrs: {
            "name": _vm.formData.freezerDescription.name,
            "counter": _vm.formData.freezerDescription.counter,
            "label": _vm.formData.freezerDescription.label,
            "placeholder": _vm.formData.freezerDescription.placeholder,
            "maxlength": _vm.formData.freezerDescription.maxlength,
            "outlined": "",
            "dense": "",
            "clearable": ""
          },
          model: {
            value: _vm.formData.freezerDescription.value,
            callback: function ($$v) {
              _vm.$set(_vm.formData.freezerDescription, "value", $$v);
            },
            expression: "formData.freezerDescription.value"
          }
        })];
      },
      proxy: true
    }, {
      key: "save-button-section",
      fn: function () {
        return [_c('v-btn', {
          staticStyle: {
            "margin-top": "20px"
          },
          attrs: {
            "color": "primary",
            "depressed": "",
            "clearable": "",
            "type": "button"
          },
          on: {
            "click": function ($event) {
              return _vm.onSave();
            }
          }
        }, [_vm._v(" Save ")])];
      },
      proxy: true
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }